// 首页数据相关信息api
export const homePageUrl = `${process.env.STATIC}dataMock/indexData.json`;

// 开发者中心相关数据
export const devCenterUrl = `${process.env.STATIC}dataMock/devCenterData.json`;

// 示例代码中心相关数据
export const liveDemoUrl = `${process.env.STATIC}dataMock/liveDemoData.json`;



// WEBPACK FOOTER //
// ./src/api/data.js